import {CesiumIonDefaultAccessToken} from './config'
import * as Cesium from "cesium";
import 'cesium/Source/Widgets/widgets.css'
import mask from "@/assets/json/shanxiout.json"
import river from '@/assets/json/River_5level.json'
import waterNormals from '@/assets/waterNormals.jpg'


export const initCesium = () => {
    // 使用Cesium官方示例中的Token
    Cesium.Ion.defaultAccessToken = CesiumIonDefaultAccessToken || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzZWYwNmY2NS1mMDZhLTRiZTAtYjQ0OC0zYzY3MjYzZDhlZmYiLCJpZCI6MTUzMDM1LCJpYXQiOjE3NTYzNjk1NDV9.lw41Vd-dcwvvBJ9oZZGS7ECtVv7Yaf6epsNj882QL2E'
    const viewer = new Cesium.Viewer('cesiumContainer', {
        shouldAnimate: true,
        animation: false, // 是否创建动画小器件，左下角仪表
        baseLayerPicker: false, // 是否显示图层选择器
        fullscreenButton: false, // 是否显示全屏按钮
        geocoder: false, // 是否显示geocoder小器件，右上角查询按钮
        homeButton: false, // 是否显示Home按钮
        infoBox: false, // 是否显示信息框
        sceneModePicker: false, // 是否显示3D/2D选择器
        selectionIndicator: false, // 是否显示选取指示器组件
        timeline: false, // 是否显示时间轴
        navigationHelpButton: false, // 是否显示右上角的帮助按钮
        scene3DOnly: false, // 如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源
        terrainProvider: Cesium.createWorldTerrain()
    })

    viewer.cesiumWidget.creditContainer.style.display = 'none' // 隐藏版权信息
    viewer.scene.globe.depthTestAgainstTerrain = true //深度监测
    viewer.scene.debugShowFramesPerSecond = false;

    var utc = Cesium.JulianDate.fromDate(new Date("2023/09/20 06:00:00"));
    //北京时间=UTC+8=GMT+8
    viewer.clockViewModel.currentTime = Cesium.JulianDate.addHours(utc, 8, new Cesium.JulianDate());

    viewer.camera.setView({
        // Cesium的坐标是以地心为原点，一向指向南美洲，一向指向亚洲，一向指向北极州
        // fromDegrees()方法，将经纬度和高程转换为世界坐标
        destination: Cesium.Cartesian3.fromDegrees(109.84, 35.55, 420000),
        orientation: {
            // 指向
            heading: 6.2750128595724615,
            // 视角
            pitch: -1.570681686183447,
            roll: 0
        }
    })


    creatBoundary(viewer)
    load3DTiles(viewer)
    initRiver(viewer)
    clickFun(viewer)

    // initLevel(viewer)

    return viewer;
}


const load3DTiles = async (viewer) => {
    const modelUrl = (process.env.VUE_APP_GUXIAN_MODEL_URL || '').trim()
        || (process.env.NODE_ENV === 'development'
            ? 'http://localhost:80/lintao/tileset/古贤水利枢纽.glb'
            : '')
    if (!modelUrl) return

    var modelMatrix0 = Cesium.Transforms.eastNorthUpToFixedFrame(
        Cesium.Cartesian3.fromDegrees(110.4518, 36.0662, 485.4143015948)
    );

    try {
        const model = await Cesium.Model.fromGltf({
            url: modelUrl,
            modelMatrix: modelMatrix0
        });

        let tilesetModel0 = viewer.scene.primitives.add(model);

        // 原始矩阵
        let ms = tilesetModel0.modelMatrix;

        // 旋转矩阵
        let mRotate = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(-87));

        // 缩放矩阵（例如放大 10 倍）
        let scale = 7.0;
        let mScale = Cesium.Matrix4.fromUniformScale(scale);

        // 应用旋转
        Cesium.Matrix4.multiplyByMatrix3(ms, mRotate, ms);

        // 应用缩放
        Cesium.Matrix4.multiply(ms, mScale, ms);

        tilesetModel0.modelMatrix = ms;

    } catch (error) {
        console.log(`Failed to load model. ${error}`);
    }
};

const creatBoundary = async (viewer) => {


    let maskLine = mask.features;
    let positionArray = [];
    // 获取区域的经纬度坐标
    for (let i = 0; i < maskLine[0].geometry.coordinates[0][0].length; i++) {
        let coor = maskLine[0].geometry.coordinates[0][0][i];
        positionArray.push(coor[0]);
        positionArray.push(coor[1]);
    }
    // 遮罩
    let polygonEntity = new Cesium.Entity({
        polygon: {
            hierarchy: {
                positions: Cesium.Cartesian3.fromDegreesArray([60, 0, 60, 90, 160, 90, 160, 0]),
                // 中心挖空的“洞”
                holes: [{
                    positions: Cesium.Cartesian3.fromDegreesArray(positionArray)
                }]
            },
            material: new Cesium.Color(15 / 255.0, 38 / 255.0, 84 / 255.0, 0.7)
        }
    })
    viewer.entities.add(polygonEntity);

    let entity = new Cesium.Entity({
        polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(positionArray),
            width: 2,
            material: new Cesium.Color(105 / 255.0, 105 / 255.0, 105 / 255.0, 1),
            clampToGround: true,
        }

    })
    viewer.entities.add(entity);

}

const initRiver = async (viewer) => {
    Cesium.GeoJsonDataSource.load(river, {
        clampToGround: true,
    }).then((dataSource) => {
        let entities = dataSource.entities.values;
        pipeLineStyle(entities, 10, '#cec40b')
        viewer.dataSources.add(dataSource)
    })
}

const pipeLineStyle = (entities, width, color) => {
    for (var o = 0; o < entities.length; o++) {
        var r = entities[o];
        r.nameID = o;   //给每条线添加一个编号，方便之后对线修改样式
        r.polyline.width = width;  //添加默认样式
        (r.polyline.material = new Cesium.PolylineGlowMaterialProperty({
            glowPower: 0.1, //一个数字属性，指定发光强度，占总线宽的百分比。
            color: Cesium.Color.fromCssColorString(color)
        }), width)
    }
}

const clickFun = (viewer) => {
    let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
    handler.setInputAction((event) => {

        let pick = viewer.scene.pick(event.position);
        let cartesian = viewer.camera.pickEllipsoid(event.position);
        let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
        let lng = Cesium.Math.toDegrees(cartographic.longitude); // 经度
        let lat = Cesium.Math.toDegrees(cartographic.latitude); // 纬度
        let alt = cartographic.height; // 高度，椭球面height永远等于0
        let coordinate = {
            longitude: Number(lng.toFixed(6)),
            latitude: Number(lat.toFixed(6)),
            altitude: Number(alt.toFixed(2))
        };
        console.log(coordinate);
        var head = viewer.scene.camera.heading;
        var pitch = viewer.scene.camera.pitch;
        var roll = viewer.scene.camera.roll;
        var info = {head: head, pitch: pitch, roll: roll};
        // 获取位置 wgs84的地心坐标系，x,y坐标值以弧度来表示
        var position = viewer.scene.camera.positionCartographic; //经纬度单位为弧度，高程单位为米.
        //以下方式也可以获取相机位置只是返回的坐标系不一样
        // 弧度转经纬度
        var longitude = Cesium.Math.toDegrees(position.longitude).toFixed(6);
        var latitude = Cesium.Math.toDegrees(position.latitude).toFixed(6);
        var height = position.height;
        console.log({lng: longitude, lat: latitude, h: height, mat: info});
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
}

const  initLevel=(viewer) =>{


    let coordinateArray = [
        110.429428, 36.199773,
        110.46144, 36.198617,
        110.449154, 36.150535,
        110.426819, 36.151044,
    ]


    let outLinePositionArray = Cesium.Cartesian3.fromDegreesArray(coordinateArray);

   let downLevel = viewer.scene.primitives.add(new Cesium.Primitive({
        geometryInstances: new Cesium.GeometryInstance({
            geometry: new Cesium.PolygonGeometry({
                polygonHierarchy: new Cesium.PolygonHierarchy(outLinePositionArray),
                vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
                // height: 100,
                extrudedHeight: 5000
            })
        }),
        appearance: new Cesium.EllipsoidSurfaceAppearance({
            aboveGround: true,
        }),
        show: true
    }));

    downLevel.appearance.material = new Cesium.Material({
        fabric: {
            type: 'Water',
            uniforms: {
                // baseWaterColor: new Cesium.Color(64 / 255.0, 157 / 255.0, 253 / 255.0, 0.5),
                // baseWaterColor: new Cesium.Color(35/ 255.0, 121/255.0, 95/255.0, 0.8),
                baseWaterColor: new Cesium.Color(31 / 255.0, 107 / 255.0, 84 / 255.0, 0.7),
                normalMap: waterNormals,
                frequency: 1000.0,
                animationSpeed: 0.05,
                amplitude: 10.0,
            }
        },

    });

}

